// // CustomerDetails.jsx

// import Header from "../Components/Header";
// import "./CustomerDetails.css";
// import { useNavigate } from "react-router-dom";

// const CustomerDetails = () => {
//   const navigate = useNavigate();

//   const orders = [
//     {
//       id: "#ORD-1001",
//       product: "Banarasi Silk Saree",
//       date: "April 15, 2026",
//       amount: "₹12,500",
//       status: "Delivered",
//     },
//     {
//       id: "#ORD-0987",
//       product: "Chanderi Kurta Set",
//       date: "March 28, 2026",
//       amount: "₹4,500",
//       status: "Delivered",
//     },
//     {
//       id: "#ORD-0876",
//       product: "Embroidered Dupatta",
//       date: "March 10, 2026",
//       amount: "₹2,800",
//       status: "Delivered",
//     },
//     {
//       id: "#ORD-0765",
//       product: "Designer Lehenga",
//       date: "February 20, 2026",
//       amount: "₹35,000",
//       status: "Delivered",
//     },
//   ];

//   return (
//     <div className="customerdetails-page">
//       <Header />

//       {/* Heading */}
//       <div className="customerdetails-heading">
//         <span
//           className="customerdetails-back"
//           onClick={() => navigate("/customers")}
//         >
//           ←
//         </span>

//         <div>
//           <h1>Customer Details</h1>
//           <p>View complete customer information</p>
//         </div>
//       </div>

//       {/* Top Card */}
//       <div className="customerdetails-card">
//         {/* TOP */}
//         <div className="customerdetails-top">
//           <h2>Priya Sharma</h2>
//         </div>

//         {/* BOTTOM */}
//         <div className="customerdetails-bottom">
//           {/* LEFT */}
//           <div className="customerdetails-left">
//             <div className="customerdetails-info">
//               <div className="customerdetails-item">
//                 <div className="customerdetails-icon">
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     height="24px"
//                     viewBox="0 -960 960 960"
//                     width="24px"
//                     fill="#8B1A10"
//                   >
//                     <path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280L160-640v400h640v-400L480-440Zm0-80 320-200H160l320 200ZM160-640v-80 480-400Z" />
//                   </svg>
//                 </div>
//                 <div>
//                   <p>Email Address</p>
//                   <h4>priya@example.com</h4>
//                 </div>
//               </div>

//               <div className="customerdetails-item">
//                 <div className="customerdetails-icon">
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     height="24px"
//                     viewBox="0 -960 960 960"
//                     width="24px"
//                     fill="#EECECD"
//                   >
//                     <path d="M798-120q-125 0-247-54.5T329-329Q229-429 174.5-551T120-798q0-18 12-30t30-12h162q14 0 25 9.5t13 22.5l26 140q2 16-1 27t-11 19l-97 98q20 37 47.5 71.5T387-386q31 31 65 57.5t72 48.5l94-94q9-9 23.5-13.5T670-390l138 28q14 4 23 14.5t9 23.5v162q0 18-12 30t-30 12ZM241-600l66-66-17-94h-89q5 41 14 81t26 79Zm358 358q39 17 79.5 27t81.5 13v-88l-94-19-67 67ZM241-600Zm358 358Z" />
//                   </svg>
//                 </div>
//                 <div>
//                   <p>Phone Number</p>
//                   <h4>+91 98765 43210</h4>
//                 </div>
//               </div>

//               <div className="customerdetails-item">
//                 <div className="customerdetails-icon">
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     height="24px"
//                     viewBox="0 -960 960 960"
//                     width="24px"
//                     fill="#EAC452"
//                   >
//                     <path d="M536.5-503.5Q560-527 560-560t-23.5-56.5Q513-640 480-640t-56.5 23.5Q400-593 400-560t23.5 56.5Q447-480 480-480t56.5-23.5ZM480-186q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800q-101 0-170.5 69.5T240-552q0 71 59 162.5T480-186Zm0 106Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z" />
//                   </svg>
//                 </div>
//                 <div>
//                   <p>Location</p>
//                   <h4>Mumbai, Maharashtra</h4>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* RIGHT */}
//           <div className="customerdetails-right">
//             <div className="customerdetails-stat customergreen">
//               <span>
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   height="24px"
//                   viewBox="0 -960 960 960"
//                   width="24px"
//                   fill="#78A75A"
//                 >
//                   <path d="M200-80q-33 0-56.5-23.5T120-160v-480q0-33 23.5-56.5T200-720h80q0-83 58.5-141.5T480-920q83 0 141.5 58.5T680-720h80q33 0 56.5 23.5T840-640v480q0 33-23.5 56.5T760-80H200Zm0-80h560v-480H200v480Zm421.5-298.5Q680-517 680-600h-80q0 50-35 85t-85 35q-50 0-85-35t-35-85h-80q0 83 58.5 141.5T480-400q83 0 141.5-58.5ZM360-720h240q0-50-35-85t-85-35q-50 0-85 35t-35 85ZM200-160v-480 480Z" />
//                 </svg>
//               </span>
//               <div>
//                 <p>Total Orders</p>
//                 <h3>8</h3>
//               </div>
//             </div>

//             <div className="customerdetails-stat customerpurple">
//               <span>
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   height="24px"
//                   viewBox="0 -960 960 960"
//                   width="24px"
//                   fill="#8C1AF6"
//                 >
//                   <path d="M441-120v-86q-53-12-91.5-46T293-348l74-30q15 48 44.5 73t77.5 25q41 0 69.5-18.5T587-356q0-35-22-55.5T463-458q-86-27-118-64.5T313-614q0-65 42-101t86-41v-84h80v84q50 8 82.5 36.5T651-650l-74 32q-12-32-34-48t-60-16q-44 0-67 19.5T393-614q0 33 30 52t104 40q69 20 104.5 63.5T667-358q0 71-42 108t-104 46v84h-80Z" />
//                 </svg>
//               </span>
//               <div>
//                 <p>Total Spent</p>
//                 <h3>₹1.2L</h3>
//               </div>
//             </div>

//             <div className="customerdetails-stat customerblue">
//               <span>
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   height="24px"
//                   viewBox="0 -960 960 960"
//                   width="24px"
//                   fill="#0000F5"
//                 >
//                   <path d="M200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Z" />
//                 </svg>
//               </span>
//               <div>
//                 <p>Customer Since</p>
//                 <h3>Jan 2024</h3>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Order History */}
//       <div className="customerdetails-history">
//         <h2>Order History</h2>

//         <table>
//           <thead>
//             <tr>
//               <th>Order ID</th>
//               <th>Product</th>
//               <th>Date</th>
//               <th>Amount</th>
//               <th>Status</th>
//             </tr>
//           </thead>

//           <tbody>
//             {orders.map((item, index) => (
//               <tr key={index}>
//                 <td>{item.id}</td>
//                 <td>{item.product}</td>
//                 <td>{item.date}</td>
//                 <td>{item.amount}</td>
//                 <td>
//                   <span className="customerdetails-status">{item.status}</span>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default CustomerDetails;





import Header from "../Components/Header";
import "./CustomerDetails.css";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import API_BASE from "../config";

const CustomerDetails = () => {
  const navigate = useNavigate();

  const { id } = useParams();

  const [customer, setCustomer] = useState(null);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_BASE}/Customer/${id}`)
      .then((res) => {
        if (!res.ok) {
          throw new Error("Failed to fetch customer");
        }

        return res.json();
      })
      .then((data) => {
        setCustomer(data);
      })
      .catch((err) => {
        console.error("Error fetching customer:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };

  const formatCurrency = (amount) => {
    return `₹${amount.toLocaleString("en-IN")}`;
  };

  if (loading) {
    return (
      <div className="customerdetails-page">
        <Header />
        <h2 style={{ padding: "30px" }}>Loading customer...</h2>
      </div>
    );
  }

  if (!customer) {
    return (
      <div className="customerdetails-page">
        <Header />
        <h2 style={{ padding: "30px" }}>Customer not found</h2>
      </div>
    );
  }

  return (
    <div className="customerdetails-page">
      <Header />

      {/* Heading */}
      <div className="customerdetails-heading">
        <span
          className="customerdetails-back"
          onClick={() => navigate("/customers")}
        >
          ←
        </span>

        <div>
          <h1>Customer Details</h1>
          <p>View complete customer information</p>
        </div>
      </div>

      {/* Top Card */}
      <div className="customerdetails-card">
        {/* TOP */}
        <div className="customerdetails-top">
          <h2>{customer.name}</h2>
        </div>

        {/* BOTTOM */}
        <div className="customerdetails-bottom">
          {/* LEFT */}
          <div className="customerdetails-left">
            <div className="customerdetails-info">
              {/* EMAIL */}
              <div className="customerdetails-item">
                <div className="customerdetails-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24px"
                    viewBox="0 -960 960 960"
                    width="24px"
                    fill="#8B1A10"
                  >
                    <path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280L160-640v400h640v-400L480-440Zm0-80 320-200H160l320 200ZM160-640v-80 480-400Z" />
                  </svg>
                </div>

                <div>
                  <p>Email Address</p>
                  <h4>{customer.email}</h4>
                </div>
              </div>

              {/* PHONE */}
              <div className="customerdetails-item">
                <div className="customerdetails-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24px"
                    viewBox="0 -960 960 960"
                    width="24px"
                    fill="#EECECD"
                  >
                    <path d="M798-120q-125 0-247-54.5T329-329Q229-429 174.5-551T120-798q0-18 12-30t30-12h162q14 0 25 9.5t13 22.5l26 140q2 16-1 27t-11 19l-97 98q20 37 47.5 71.5T387-386q31 31 65 57.5t72 48.5l94-94q9-9 23.5-13.5T670-390l138 28q14 4 23 14.5t9 23.5v162q0 18-12 30t-30 12ZM241-600l66-66-17-94h-89q5 41 14 81t26 79Zm358 358q39 17 79.5 27t81.5 13v-88l-94-19-67 67ZM241-600Zm358 358Z" />
                  </svg>
                </div>

                <div>
                  <p>Phone Number</p>
                  <h4>{customer.phoneNumber}</h4>
                </div>
              </div>

              {/* LOCATION */}
              <div className="customerdetails-item">
                <div className="customerdetails-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24px"
                    viewBox="0 -960 960 960"
                    width="24px"
                    fill="#EAC452"
                  >
                    <path d="M536.5-503.5Q560-527 560-560t-23.5-56.5Q513-640 480-640t-56.5 23.5Q400-593 400-560t23.5 56.5Q447-480 480-480t56.5-23.5ZM480-186q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800q-101 0-170.5 69.5T240-552q0 71 59 162.5T480-186Zm0 106Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z" />
                  </svg>
                </div>

                <div>
                  <p>Location</p>
                  <h4>
                    {customer.city}, {customer.state}
                  </h4>
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT */}
          <div className="customerdetails-right">
            {/* TOTAL ORDERS */}
            <div className="customerdetails-stat customergreen">
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="24px"
                  viewBox="0 -960 960 960"
                  width="24px"
                  fill="#78A75A"
                >
                  <path d="M200-80q-33 0-56.5-23.5T120-160v-480q0-33 23.5-56.5T200-720h80q0-83 58.5-141.5T480-920q83 0 141.5 58.5T680-720h80q33 0 56.5 23.5T840-640v480q0 33-23.5 56.5T760-80H200Zm0-80h560v-480H200v480Zm421.5-298.5Q680-517 680-600h-80q0 50-35 85t-85 35q-50 0-85-35t-35-85h-80q0 83 58.5 141.5T480-400q83 0 141.5-58.5ZM360-720h240q0-50-35-85t-85-35q-50 0-85 35t-35 85ZM200-160v-480 480Z" />
                </svg>
              </span>

              <div>
                <p>Total Orders</p>
                <h3>{customer.totalOrders}</h3>
              </div>
            </div>

            {/* TOTAL SPENT */}
            <div className="customerdetails-stat customerpurple">
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="24px"
                  viewBox="0 -960 960 960"
                  width="24px"
                  fill="#8C1AF6"
                >
                  <path d="M441-120v-86q-53-12-91.5-46T293-348l74-30q15 48 44.5 73t77.5 25q41 0 69.5-18.5T587-356q0-35-22-55.5T463-458q-86-27-118-64.5T313-614q0-65 42-101t86-41v-84h80v84q50 8 82.5 36.5T651-650l-74 32q-12-32-34-48t-60-16q-44 0-67 19.5T393-614q0 33 30 52t104 40q69 20 104.5 63.5T667-358q0 71-42 108t-104 46v84h-80Z" />
                </svg>
              </span>

              <div>
                <p>Total Spent</p>
                <h3>{formatCurrency(customer.totalSpent)}</h3>
              </div>
            </div>

            {/* CUSTOMER SINCE */}
            <div className="customerdetails-stat customerblue">
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="24px"
                  viewBox="0 -960 960 960"
                  width="24px"
                  fill="#0000F5"
                >
                  <path d="M200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Z" />
                </svg>
              </span>

              <div>
                <p>Customer Since</p>
                <h3>
                  {new Date(customer.createdAt).toLocaleDateString("en-IN", {
                    month: "short",
                    year: "numeric",
                  })}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ORDER HISTORY */}
      <div className="customerdetails-history">
        <h2>Order History</h2>

        <table>
          <thead>
            <tr>
              <th>Order ID</th>
              <th>Date</th>
              <th>Amount</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>
            {customer.orders.length === 0 ? (
              <tr>
                <td colSpan="4" style={{ textAlign: "center" }}>
                  No orders found
                </td>
              </tr>
            ) : (
              customer.orders.map((item) => (
                <tr key={item.id}>
                  <td>{item.orderNumber}</td>

                  <td>{formatDate(item.orderDate)}</td>

                  <td>{formatCurrency(item.totalAmount)}</td>

                  <td>
                    <span className="customerdetails-status">
                      {item.status}
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CustomerDetails;